export default __webpack_public_path__ + "static/unperfect90-eab1bf03efca19cc59a02851bea815e5.png";